import { FC } from 'react'
import { Listing } from 'graphql/types'
import { getListingUrl } from 'lib/listing'
import { pluralize } from 'lib/text'
import { minTwoDigits } from 'lib/number'
import SectionHeader from 'components/SectionHeader'
import RelatedListings from 'components/RelatedListings'
import { featureListingEvent, moreListingsButtonEvent } from '../../../events'
import regionStyles from '../../../../Region.module.scss'

export type TProps = {
  condominiumName: string
  listings: Array<Listing>
  total: number
  searchUrl: string
}

const Related: FC<TProps> = ({
  condominiumName,
  listings,
  total,
  searchUrl,
}) => {
  if (!total) return null

  return (
    <div className={regionStyles.ecPageRegionSection}>
      <SectionHeader
        title={{
          value: `${minTwoDigits(total)} ${pluralize({
            count: total,
            noun: 'imóvel',
            pluralNoun: 'imóveis',
          })} em ${condominiumName}`,
        }}
      />
      <RelatedListings
        listings={listings}
        onClickListingCard={(listing) =>
          featureListingEvent({
            condominium: condominiumName,
            url: getListingUrl(listing),
            listing,
          })
        }
        onClickRelated={() =>
          moreListingsButtonEvent(condominiumName, searchUrl)
        }
        onFavoriteListing={() => null}
        onSlideCards={() => null}
        navigation={{ verticalPosition: 'bottom' }}
        bannerRelatedPosition="end"
        banner={{
          text: `Ver mais imóveis em ${condominiumName}`,
          buttonText: 'Ver todos',
          buttonUrl: searchUrl,
        }}
      />
    </div>
  )
}

export default Related
